import { useEffect, useState } from "react";
import type { Settings } from "./types";
import { settingsStore } from "./store";

type Setter = (patch: Partial<Settings> | ((prev: Settings) => Settings)) => void;

export function useSettings(): [Settings, Setter] {
  const [s, setS] = useState<Settings>(settingsStore.get());

  useEffect(() => {
    const unsubscribe = settingsStore.subscribe(setS);

    return () => {
      unsubscribe();
    };
  }, []);

  const setSettings: Setter = (patch) => {
    settingsStore.set(patch as any);
  };

  return [s, setSettings];
}
